var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopupClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5006,
    cy: 30.6646,
    r: 29.0335,
    stroke: "#ED4863",
    strokeWidth: 3.2622
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4006 19L19 23.4006L21.2471 25.6478L26.8025 31.2968L21.2471 36.8522L19 39.0057L23.4006 43.5L25.6478 41.2529L31.2968 35.6038L36.8522 41.2529L39.0057 43.5L43.5 39.0057L41.2529 36.8522L35.6038 31.2968L41.2529 25.6478L43.5 23.4006L39.0057 19L36.8522 21.2471L31.2968 26.8025L25.6478 21.2471L23.4006 19Z",
    fill: "#ED4863"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupClose);
export default __webpack_public_path__ + "static/media/PopupClose.d1eaeb1f14790c049e973f999b83deb0.svg";
export { ForwardRef as ReactComponent };